import app from './app';
import { AUTHORIZATION_SERVICE_URL } from '../../libs/constants';

//POST
const getAuthTokenForGuest = requestData => async (dispatch, getState, api) => {
    await api.post(AUTHORIZATION_SERVICE_URL + 'tokenGuest').then(response => {
        dispatch({ type: "SET_AUTH_TOKEN", payload: response.data });
    }).catch(error => {
        console.log(error)
        if (error.response.status) {
            dispatch({ type: "SET_TOKEN_CALL_COMPLETE" });
        }
    });
};

//POST
const getUserInfo = id => async (dispatch, getState, api) => {
    await api.post(AUTHORIZATION_SERVICE_URL + 'userInfo')
        .then(response => {
            if (response.data.userId) {
                dispatch({ type: "SET_AUTHORIZED_USER", data: response.data });

                if (response.data.authSessionResponse) {
                    const authSessionResponse = JSON.parse(response.data.authSessionResponse);

                    if (authSessionResponse.quote) {
                        dispatch({
                            type: "SET_QUOTE_SUMMARY",
                            data: authSessionResponse.quote.quoteSummary
                        });
                    }

                    if (authSessionResponse.newOrder) {
                        dispatch({
                            type: "SET_ORDER_DATA", data: {
                                type: "leftover",
                                orderData: authSessionResponse.newOrder
                            }
                        });
                    }

                    if (authSessionResponse.catalog) {
                        dispatch({ type: "SET_PRE_AUTHENTICATION_CATALOG_DATA", data: authSessionResponse.catalog });
                    }

                    if (authSessionResponse.saveRequest) {
                        dispatch({ type: "SET_LEFT_OVER_SAVE_QUOTE_REQUEST", data: true });
                    }
                }
            }
            else {
                if (response.data.maintenanceEnabled) {
                    dispatch({ type: "SET_SITE_UNDER_MAINTENANCE" });
                }
                else {
                    if (!response.data.captchaEnabled) {
                        dispatch({ type: "SET_CAPTCHA_ENABLE", data: false });
                    }

                    if (response.data.changedPassword) {
                        dispatch({ type: "SET_POST_CHANGED_PASSWORD_REQUEST", data: true });
                    }

                    dispatch({ type: "SET_USER_INFO_CALL_COMPLETE" });
                }
            }
        })
        .catch(error => {
            if (error.response.status) {
                dispatch({ type: "SET_USER_INFO_CALL_COMPLETE" });
            }
        })
};

const clearAuthSessionResponse = () => {
    return {
        type: 'CLEAR_AUTH_SESSION_RESPONSE'
    }
}

const resetAuthorizationContent = () => {
    return {
        type: 'RESET_AUTHORIZATION_CONTENT'
    }
}

const authorizationActions = {
    getAuthTokenForGuest: getAuthTokenForGuest,
    getUserInfo: getUserInfo,
    clearAuthSessionResponse: clearAuthSessionResponse,
    resetAuthorizationContent
}

export default authorizationActions;